import { alpha } from '@mui/material/styles';

// A single inset editor surface for table inputs and Watchlist popovers. Keep
// the ring on the control, not the row/cell edges where grid clipping cuts it.
export const cellEditorFieldSx = {
    '&& .MuiInputBase-root': (theme) => ({
        borderRadius: '6px',
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        transition: 'border-color 120ms ease, box-shadow 120ms ease',
        '&:focus-within:not(.Mui-error)': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.16)}`,
        },
        '&.Mui-error': { borderColor: theme.palette.error.main },
        // Outlined fields keep their notch so floating labels remain legible.
        '&.MuiOutlinedInput-root': { border: 0 },
        '& .MuiOutlinedInput-notchedOutline': { border: `1px solid ${theme.palette.divider}` },
        '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.error.main },
    }),
};
